module.exports = __webpack_public_path__ + "static/PowerBI-3903ae00d76f3a6015794d152ff4439d.png";